/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  Text,
  TextAreaField,
} from "@aws-amplify/ui-react";
import { ScenarioAnalysisAssumptions } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function ScenarioAnalysisAssumptionsUpdateForm(props) {
  const {
    id: idProp,
    scenarioAnalysisAssumptions: scenarioAnalysisAssumptionsModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    PolicyAssumptions: "",
    MacroeconomicTrends: "",
    NationalRegionalVariables: "",
    EnergyUsageAndMix: "",
    TechnologyDevelopments: "",
  };
  const [PolicyAssumptions, setPolicyAssumptions] = React.useState(
    initialValues.PolicyAssumptions
  );
  const [MacroeconomicTrends, setMacroeconomicTrends] = React.useState(
    initialValues.MacroeconomicTrends
  );
  const [NationalRegionalVariables, setNationalRegionalVariables] =
    React.useState(initialValues.NationalRegionalVariables);
  const [EnergyUsageAndMix, setEnergyUsageAndMix] = React.useState(
    initialValues.EnergyUsageAndMix
  );
  const [TechnologyDevelopments, setTechnologyDevelopments] = React.useState(
    initialValues.TechnologyDevelopments
  );
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = scenarioAnalysisAssumptionsRecord
      ? { ...initialValues, ...scenarioAnalysisAssumptionsRecord }
      : initialValues;
    setPolicyAssumptions(cleanValues.PolicyAssumptions);
    setMacroeconomicTrends(cleanValues.MacroeconomicTrends);
    setNationalRegionalVariables(cleanValues.NationalRegionalVariables);
    setEnergyUsageAndMix(cleanValues.EnergyUsageAndMix);
    setTechnologyDevelopments(cleanValues.TechnologyDevelopments);
    setErrors({});
  };
  const [
    scenarioAnalysisAssumptionsRecord,
    setScenarioAnalysisAssumptionsRecord,
  ] = React.useState(scenarioAnalysisAssumptionsModelProp);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? await DataStore.query(ScenarioAnalysisAssumptions, idProp)
        : scenarioAnalysisAssumptionsModelProp;
      setScenarioAnalysisAssumptionsRecord(record);
    };
    queryData();
  }, [idProp, scenarioAnalysisAssumptionsModelProp]);
  React.useEffect(resetStateValues, [scenarioAnalysisAssumptionsRecord]);
  const validations = {
    PolicyAssumptions: [],
    MacroeconomicTrends: [],
    NationalRegionalVariables: [],
    EnergyUsageAndMix: [],
    TechnologyDevelopments: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          PolicyAssumptions,
          MacroeconomicTrends,
          NationalRegionalVariables,
          EnergyUsageAndMix,
          TechnologyDevelopments,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(
            ScenarioAnalysisAssumptions.copyOf(
              scenarioAnalysisAssumptionsRecord,
              (updated) => {
                Object.assign(updated, modelFields);
              }
            )
          );
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "ScenarioAnalysisAssumptionsUpdateForm")}
      {...rest}
    >
      <Heading
        level={4}
        children="Scenario Analysis Key Assumptions"
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Heading>
      <Heading
        children="IFRS S2 paragraph 22 b ii."
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Heading>
      <Text
        children="Update this record that defines the key assumptions you used in your scenario analysis."
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement3")}
      ></Divider>
      <TextAreaField
        label="Assumptions about climate-related policies in the jurisdictions you operate in"
        isRequired={false}
        isReadOnly={false}
        value={PolicyAssumptions}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              PolicyAssumptions: value,
              MacroeconomicTrends,
              NationalRegionalVariables,
              EnergyUsageAndMix,
              TechnologyDevelopments,
            };
            const result = onChange(modelFields);
            value = result?.PolicyAssumptions ?? value;
          }
          if (errors.PolicyAssumptions?.hasError) {
            runValidationTasks("PolicyAssumptions", value);
          }
          setPolicyAssumptions(value);
        }}
        onBlur={() =>
          runValidationTasks("PolicyAssumptions", PolicyAssumptions)
        }
        errorMessage={errors.PolicyAssumptions?.errorMessage}
        hasError={errors.PolicyAssumptions?.hasError}
        {...getOverrideProps(overrides, "PolicyAssumptions")}
      ></TextAreaField>
      <TextAreaField
        label="Macroeconomic trends"
        isRequired={false}
        isReadOnly={false}
        value={MacroeconomicTrends}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              PolicyAssumptions,
              MacroeconomicTrends: value,
              NationalRegionalVariables,
              EnergyUsageAndMix,
              TechnologyDevelopments,
            };
            const result = onChange(modelFields);
            value = result?.MacroeconomicTrends ?? value;
          }
          if (errors.MacroeconomicTrends?.hasError) {
            runValidationTasks("MacroeconomicTrends", value);
          }
          setMacroeconomicTrends(value);
        }}
        onBlur={() =>
          runValidationTasks("MacroeconomicTrends", MacroeconomicTrends)
        }
        errorMessage={errors.MacroeconomicTrends?.errorMessage}
        hasError={errors.MacroeconomicTrends?.hasError}
        {...getOverrideProps(overrides, "MacroeconomicTrends")}
      ></TextAreaField>
      <TextAreaField
        label="National or regional variables (e.g. demographics, weather, land use etc)"
        isRequired={false}
        isReadOnly={false}
        value={NationalRegionalVariables}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              PolicyAssumptions,
              MacroeconomicTrends,
              NationalRegionalVariables: value,
              EnergyUsageAndMix,
              TechnologyDevelopments,
            };
            const result = onChange(modelFields);
            value = result?.NationalRegionalVariables ?? value;
          }
          if (errors.NationalRegionalVariables?.hasError) {
            runValidationTasks("NationalRegionalVariables", value);
          }
          setNationalRegionalVariables(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "NationalRegionalVariables",
            NationalRegionalVariables
          )
        }
        errorMessage={errors.NationalRegionalVariables?.errorMessage}
        hasError={errors.NationalRegionalVariables?.hasError}
        {...getOverrideProps(overrides, "NationalRegionalVariables")}
      ></TextAreaField>
      <TextAreaField
        label="Energy usage and mix"
        isRequired={false}
        isReadOnly={false}
        value={EnergyUsageAndMix}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              PolicyAssumptions,
              MacroeconomicTrends,
              NationalRegionalVariables,
              EnergyUsageAndMix: value,
              TechnologyDevelopments,
            };
            const result = onChange(modelFields);
            value = result?.EnergyUsageAndMix ?? value;
          }
          if (errors.EnergyUsageAndMix?.hasError) {
            runValidationTasks("EnergyUsageAndMix", value);
          }
          setEnergyUsageAndMix(value);
        }}
        onBlur={() =>
          runValidationTasks("EnergyUsageAndMix", EnergyUsageAndMix)
        }
        errorMessage={errors.EnergyUsageAndMix?.errorMessage}
        hasError={errors.EnergyUsageAndMix?.hasError}
        {...getOverrideProps(overrides, "EnergyUsageAndMix")}
      ></TextAreaField>
      <TextAreaField
        label="Technology developments"
        isRequired={false}
        isReadOnly={false}
        value={TechnologyDevelopments}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              PolicyAssumptions,
              MacroeconomicTrends,
              NationalRegionalVariables,
              EnergyUsageAndMix,
              TechnologyDevelopments: value,
            };
            const result = onChange(modelFields);
            value = result?.TechnologyDevelopments ?? value;
          }
          if (errors.TechnologyDevelopments?.hasError) {
            runValidationTasks("TechnologyDevelopments", value);
          }
          setTechnologyDevelopments(value);
        }}
        onBlur={() =>
          runValidationTasks("TechnologyDevelopments", TechnologyDevelopments)
        }
        errorMessage={errors.TechnologyDevelopments?.errorMessage}
        hasError={errors.TechnologyDevelopments?.hasError}
        {...getOverrideProps(overrides, "TechnologyDevelopments")}
      ></TextAreaField>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement4")}
      ></Divider>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || scenarioAnalysisAssumptionsModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || scenarioAnalysisAssumptionsModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
